export const getShareData = ({ year, make, model, id, shareSource }) => {
  if (typeof window === 'undefined') return null;

  const params = {
    id,
    utm_source: 'hidden_gems_share',
    utm_account: 'edmunds',
    utm_content: shareSource,
  };

  const urlObj = new URL(window.location.pathname, window.location.origin);

  Object.entries(params).forEach(([key, value]) => urlObj.searchParams.set(key, value));
  urlObj.hash = 'lease-deals-preview';

  return {
    title: `Check out this ${year} ${make} ${model} lease deal on Edmunds!`,
    url: urlObj.toString(),
  };
};
